var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Valuation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.15 8.1h-1.14a28.93 28.93 0 000 57.86h.43a28.933 28.933 0 00.71-57.86zm10.59 40.46A18.44 18.44 0 0138 53.11v8.17L25.57 46.94 38 32.44v10l14.38-13.63L38 14.52v8.23c-11.15 1-26.76 11.56-16.13 33.72-3.87-4.41-8.41-7.8-9.33-19.47a25.1 25.1 0 0125.07-25.07h.48A17.88 17.88 0 0151 18.31c9.46 11.98 6.38 22.31-1.26 30.25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Valuation.d731e3f6.svg";
export { SvgK1Valuation as ReactComponent };